module.exports = __webpack_public_path__ + "static/media/logo_vertical.e4784a51.png";